import React from 'react';

interface CartItemEditActionsProps {
  onCancel: () => void;
  onUpdate: () => void;
}

const CartItemEditActions: React.FC<CartItemEditActionsProps> = ({
  onCancel,
  onUpdate,
}) => {
  return (
    <div className="flex gap-2">
      <button
        onClick={onCancel}
        className="flex-1 px-4 py-2 bg-gray-700 text-white rounded-lg hover:bg-gray-600 transition-colors"
      >
        Cancel
      </button>
      <button
        onClick={onUpdate}
        className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
      >
        Update
      </button>
    </div>
  );
};

export default CartItemEditActions;

